import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { isProgramOrGuide } from '@/components/app/cards/PacksList/types';
import { PacksContext } from '@/components/app/layout/PacksProvider';
import Layout from '@/components/layout/LayoutWrapper';
import SearchBar from '@/components/SearchBar';
import { OnResultClick } from '@/components/SearchBar/types';
import { useGuidePlay } from '@/hooks/app/useGuidePlay';
import { InitRequest, useInitState } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const messages = defineMessages({
	title: {
		id: 'app.components.screenTitle.searchHeading',
		defaultMessage: 'Search',
		description: 'The title of the page where users can search for content',
	},
});

const Search = () => {
	useInitState({ requests: [InitRequest.USER, InitRequest.DEVICE] });
	const { formatMessage } = useIntl();
	const { setPageTitle } = useContext(PacksContext);
	const router = useRouter();
	const onGuidePlay = useGuidePlay();

	useEffect(() => {
		setPageTitle(formatMessage(messages.title));
	}, [setPageTitle, formatMessage]);

	const onResultClick: OnResultClick = async item => {
		if (!item.guide_id) {
			await router.push(`/app/program/${item.program_id}`);
		} else {
			await onGuidePlay(item.guide_id);
		}
	};

	return (
		<Layout pageName="search">
			<SearchBar resultFilter={isProgramOrGuide} onResultClick={onResultClick} />
		</Layout>
	);
};

export default Search;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context, [InitRequest.DEVICE, InitRequest.USER]);

	return {
		props: {
			appHeaderProps: {
				pageTitle: messages.title,
			},
			initialState: {
				...initialState,
				theme: {
					webAppLayout: 'full',
				},
			},
		},
	};
};
